<header class="shell-bar">
  <div class="brand">
    <img
      src="assets/media/logos/coreact-investigator-portal.png"
      alt="Coreact Investigator Portal"
      class="brand-logo"
    />
    <nav *ngIf="breadcrumbs.crumbs().length" class="breadcrumb" [attr.aria-label]="text('Breadcrumb', 'Διαδρομή')">
      <ol>
        <li *ngFor="let crumb of breadcrumbs.crumbs(); let last = last">
          <a *ngIf="crumb.link; else current" [routerLink]="crumb.link">{{ crumb.label }}</a>
          <ng-template #current><span [attr.aria-current]="last ? 'page' : null">{{ crumb.label }}</span></ng-template>
          <i *ngIf="!last" class="pi pi-angle-right" aria-hidden="true"></i>
        </li>
      </ol>
    </nav>
  </div>

  <div class="user-area">
    <button pButton type="button" class="icon-button language-button p-button-text" (click)="toggleLanguage()" [attr.aria-label]="text('Change language', 'Αλλαγή γλώσσας')" [title]="text('Change language', 'Αλλαγή γλώσσας')">
      <span>{{ translation.currentLanguage() === 'en' ? 'ΕΛ' : 'EN' }}</span>
    </button>
    <button
      pButton
      type="button"
      class="theme-button p-button-text"
      [attr.aria-label]="theme.mode() === 'light' ? text('Use dark theme', 'Σκούρο θέμα') : text('Use light theme', 'Φωτεινό θέμα')"
      (click)="toggleTheme()"
    >
      <i [class]="theme.mode() === 'light' ? 'pi pi-moon' : 'pi pi-sun'" aria-hidden="true"></i>
    </button>
    <button
      pButton
      type="button"
      class="icon-button notification-button p-button-text"
      [attr.aria-label]="bellLabel()"
      aria-haspopup="dialog"
      (click)="panel.toggle($event)"
    >
      <i class="pi pi-bell" aria-hidden="true"></i>
      <span *ngIf="notifications.items().length" class="notification-badge" aria-hidden="true">{{ badgeText() }}</span>
    </button>
    <p-popover #panel [style]="{ width: '380px', maxWidth: 'calc(100vw - 32px)' }" ariaLabel="Notifications">
      <div class="notif">
        <div class="notif-header">
          <div class="notif-title" role="heading" aria-level="2">{{ text('Notifications', 'Ειδοποιήσεις') }}</div>
          <p-button
            *ngIf="notifications.items().length"
            [label]="text('Mark all as read', 'Σήμανση όλων ως αναγνωσμένων')"
            [text]="true"
            size="small"
            (onClick)="notifications.markAllAsRead()"
          />
        </div>

        <div *ngIf="!notifications.items().length" class="notif-empty">
          <i class="pi pi-bell-slash" aria-hidden="true"></i>
          <span>{{ text('You are all caught up.', 'Δεν υπάρχουν νέες ειδοποιήσεις.') }}</span>
        </div>

        <ul *ngIf="notifications.items().length" class="notif-list">
          <li *ngFor="let item of notifications.items(); trackBy: trackById" class="notif-item">
            <span class="notif-icon" aria-hidden="true"><i [class]="'pi ' + view(item).icon"></i></span>
            <ng-template #notifText>
              <ng-container *ngFor="let part of view(item).parts">
                <strong *ngIf="part.code; else plain">{{ part.text }}</strong>
                <ng-template #plain>{{ part.text }}</ng-template>
              </ng-container>
            </ng-template>
            <button *ngIf="item.assignmentId; else textOnly" type="button" class="notif-text notif-open" (click)="openNotification(item, panel)">
              <ng-container *ngTemplateOutlet="notifText"></ng-container>
              <span *ngIf="item.createdAt" class="notif-time">{{ item.createdAt | portalDate:'short' }}</span>
            </button>
            <ng-template #textOnly>
              <span class="notif-text"><ng-container *ngTemplateOutlet="notifText"></ng-container></span>
            </ng-template>
            <button
              type="button"
              class="notif-check"
              [attr.aria-label]="text('Mark as read', 'Σήμανση ως αναγνωσμένη')"
              [title]="text('Mark as read', 'Σήμανση ως αναγνωσμένη')"
              (click)="notifications.markAsRead([item.id])"
            >
              <i class="pi pi-check" aria-hidden="true"></i>
            </button>
          </li>
        </ul>

        <button type="button" class="notif-footer" (click)="openQueue(panel)">
          {{ text('Open case queue', 'Άνοιγμα λίστας εντολών') }}
          <i class="pi pi-arrow-right" aria-hidden="true"></i>
        </button>
      </div>
    </p-popover>
    <details class="account-menu-container">
      <summary class="icon-button settings-button" [attr.aria-label]="text('Account settings', 'Ρυθμίσεις λογαριασμού')" [title]="text('Account settings', 'Ρυθμίσεις λογαριασμού')">
        <i class="pi pi-cog" aria-hidden="true"></i>
      </summary>
      <div class="account-menu">
        <button type="button" (click)="openSettings()"><i class="pi pi-user-edit" aria-hidden="true"></i>{{ translation.translate('settings') }}</button>
        <button type="button" (click)="logout()"><i class="pi pi-sign-out" aria-hidden="true"></i>{{ translation.translate('signOut') }}</button>
      </div>
    </details>
    <div class="avatar" aria-hidden="true">
      <img *ngIf="profile.photoUrl() as photo; else initialsText" [src]="photo" alt="" class="avatar-img" />
      <ng-template #initialsText>{{ initials }}</ng-template>
    </div>
    <span class="user-name">{{ displayName }}</span>
  </div>
</header>
